<template>
  <div class="firm-login-wrap">
    <div class="login-card">
      <div class="login-header">
        <h2>律所机构端</h2>
        <p>请使用平台运营开通后的机构账号登录</p>
      </div>
      <el-form ref="formRef" :model="form" :rules="rules" label-position="top" size="large">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="请输入登录账号" :prefix-icon="User" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入登录密码"
            :prefix-icon="Lock"
            show-password
            @keyup.enter="handleLogin"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" class="login-btn" @click="handleLogin">
            登 录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { User, Lock } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { firmLogin } from '@/api/firm/auth'
import { getTenantIdByName } from '@/api/login'
import { setFirmToken, setTenantId, getTenantId } from '@/utils/auth'
import { firmPath } from '@/views/firm-portal/registry/paths'

defineOptions({ name: 'FirmPortalLogin' })

const router = useRouter()
const route = useRoute()
const formRef = ref()
const loading = ref(false)
const form = reactive({ username: '', password: '' })
const rules = {
  username: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
  password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }]
}

async function ensureTenant() {
  if (getTenantId()) return
  const name = import.meta.env.VITE_APP_DEFAULT_LOGIN_TENANT || '紫金山'
  try {
    const id = await getTenantIdByName(name)
    if (id != null) setTenantId(Number(id))
  } catch {
    // 租户接口失败时仍尝试登录
  }
}

async function handleLogin() {
  const valid = await formRef.value?.validate().catch(() => false)
  if (!valid) return

  loading.value = true
  try {
    await ensureTenant()
    const data = await firmLogin(form)
    if (data) {
      setFirmToken({ accessToken: data.accessToken, refreshToken: data.refreshToken })
      localStorage.setItem('firmAccountId', String(data.accountId))
      localStorage.setItem('firmId', String(data.firmId))
      if (data.firmName) localStorage.setItem('firmName', data.firmName)
      localStorage.setItem('firmUserType', 'firm')
      localStorage.removeItem('merchantUserType')
      localStorage.removeItem('supplierUserType')
      ElMessage.success('登录成功')
      const redirect = typeof route.query.redirect === 'string' ? route.query.redirect : undefined
      await router.replace(redirect && redirect.startsWith(firmPath()) ? redirect : firmPath('/workbench'))
    }
  } catch {
    // axios interceptor
  } finally {
    loading.value = false
  }
}
</script>

<style lang="scss" scoped>
.firm-login-wrap {
  min-height: 100vh;
  background: linear-gradient(145deg, #0f3d3e 0%, #1a5c5e 45%, #c4a35a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.login-card {
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 12px;
  padding: 40px 32px 28px;
  box-shadow: 0 12px 40px rgba(15, 61, 62, 0.25);
}
.login-header {
  text-align: center;
  margin-bottom: 28px;
  h2 {
    margin: 0 0 8px;
    font-size: 24px;
    color: #0f3d3e;
  }
  p {
    margin: 0;
    color: #6b7280;
    font-size: 13px;
  }
}
.login-btn {
  width: 100%;
}
</style>
